import React from 'react'

const NoMovies = ({ title }) => {

    return (
        <h1 className="titulo text-center">{title}</h1>
    )
}

export default NoMovies